import { styled } from "@mui/material";

export const BookLoanFormWrapper = styled("form")(({ theme }) => {
    return {
        display: "flex",
        flexDirection: "column",
        gap: "var(--flex-gap)",
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
    }
})